// Load CSS.
require('normalize.css/normalize.css');
require('./styles/index.scss');

// Load JS.
import $ from 'jquery';

require('slick-carousel');
require('./highcharts.js');

document.addEventListener("DOMContentLoaded", () => {
  const $menuToggle = $('#menu-toggle');

  $menuToggle.click(() => {
    $('#navigation').toggleClass('menu__dropdown--open');
    $menuToggle.attr('aria-expanded', function (index, attr) {
      return attr !== 'true';
    });
  });

  const $selectedItem = $('.js-selected a');
  const $selectItems = $('.js-items');

  $selectedItem.click(function () {
    $selectItems.toggleClass('annual-reports__items--open');

    return false;
  });

  var accordionTerm = document.querySelectorAll('.accordion-term');
  var accordionDef = document.querySelectorAll('.accordion-def');

  // If javascript, hide accordion definition on load
  function jsCheck() {
    for (var i = 0; i < accordionDef.length; i++) {
      if (accordionDef[i].classList) {
        accordionDef[i].classList.add('active');
        accordionDef[0].previousElementSibling.classList.add('is-active');
      }
      else {
        accordionDef[i].className += ' active';
        accordionDef[0].previousElementSibling.classList.add('is-active');
      }
    }
  }

  jsCheck();

  // Accordion Toggle.
  for (var i = 0; i < accordionTerm.length; i++) {
    accordionTerm[i].addEventListener('click', function (e) {
      var className = 'is-active';
      // Add is-active class
      if (this.classList) {
        this.classList.toggle(className);
      }
      else {
        var classes = this.className.split(' ');
        var existingIndex = classes.indexOf(className);

        if (existingIndex >= 0) {
          classes.splice(existingIndex, 1);
        }
        else {
          classes.push(className);
        }
        this.className = classes.join(' ');
      }
      e.preventDefault();
    });
  }

  // Event carousels.
  $('.event__carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.event__carousel-nav',
    adaptiveHeight: true
  }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
    // Pause video when slide is changed.
    var carousel = document.querySelector('.event__carousel');
    var video = carousel.getElementsByTagName('video');
    video[0].pause();
  });

  $('.event__carousel-nav').slick({
    asNavFor: '.event__carousel',
    mobileFirst: true,
    focusOnSelect: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 2,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          dots: true
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 4,
          dots: true
        }
      }
    ]
  });
});
